var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "wa-chat-area",
      class: { "wa-chat-area--mobile": _vm.mobileMode },
    },
    [
      _c("WAChatHeader", {
        attrs: {
          contact: _vm.contact,
          channel: _vm.channel,
          "mobile-mode": _vm.mobileMode,
        },
        on: {
          back: function ($event) {
            return _vm.$emit("back")
          },
          "open-template": _vm.openTemplate,
          "close-conversation": _vm.closeConversation,
          "view-contact": _vm.viewContactProfile,
        },
      }),
      _vm._v(" "),
      _c("div", { staticClass: "wa-chat-area__body" }, [
        _c(
          "div",
          { staticClass: "wa-chat-area__chat" },
          [
            _c("ChatWindow", {
              key: _vm.contact._id,
              ref: "chatWindow",
              attrs: { contact: _vm.contact, "show-header": false },
            }),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }